module.exports = __webpack_public_path__ + "img/thumbs-up.2d839d53.png";